var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from "react";
function SvgPaperclip(passedProps, svgRef) {
    var props = __assign({}, passedProps);
    return (React.createElement("svg", __assign({ width: "1.5em", height: "1.5em", viewBox: "0 0 31 25", fill: "none", xmlns: "http://www.w3.org/2000/svg", color: "currentColor", ref: svgRef }, props),
        React.createElement("path", { d: "M22.982 3.777a3.169 3.169 0 00-4.453 0l-8.953 9c-2.062 2.063-2.062 5.391 0 7.407 2.016 2.062 5.344 2.062 7.406 0l7.125-7.125a1.103 1.103 0 011.547 0c.469.468.469 1.171 0 1.593l-7.078 7.125c-2.953 2.953-7.687 2.953-10.594 0-2.953-2.906-2.953-7.64 0-10.593l9-9c2.063-2.063 5.485-2.063 7.594 0 2.063 2.109 2.063 5.53 0 7.593l-8.625 8.625a3.519 3.519 0 01-5.25-.28c-1.125-1.407-.984-3.423.281-4.688l7.125-7.125a1.104 1.104 0 011.547 0c.469.468.469 1.171 0 1.593l-7.078 7.125c-.469.47-.516 1.172-.094 1.688.47.562 1.313.656 1.875.094l8.625-8.625a3.112 3.112 0 000-4.407z", fill: "#242B42" })));
}
var ForwardRef = React.forwardRef(SvgPaperclip);
export default ForwardRef;
